import OutcomeConversionService from '../../../services/outcome-conversion-service';
/**
 * Class for bet combination
 */
export default class MyBetCombinationModel {
  constructor({
    BetType = '',
    Bonus = 0,
    CombStatus = '',
    CombStatusID = 0,
    NoOfBets = 0,
    Odds = 0,
    PotWinnings = 0,
    Stake = 0,
    UnitStake = 0,
    Winnings = 0,
    Tax = 0,
    // negotiations
    PotWin = 0,
  }) {
    this.betType = BetType;
    this.bonus = Bonus;
    this.combStatus = CombStatus;
    this.combinationStatusId = CombStatusID;
    this.numOfBets = NoOfBets;
    this.odds = OutcomeConversionService.outcomeConverter(Odds);
    this.potWinnings = PotWinnings !== 0 ? PotWinnings : PotWin;
    this.stake = Stake;
    this.unitStake = UnitStake;
    this.winnings = Winnings;
    this.tax = Tax;
  }
}
